import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Logo } from '@els/els-react--logo';
import { Button } from '@els/els-react--button';
import AppStorage from '@Services/AppStorage';
import Auth from '@Services/Auth';
import Login from '@Services/Login';
import LoginPageWrapper from '../../../Components/LoginPageWrapper';

import './ConfirmationSuccessDialog.scss';

function ConfirmationSuccessDialog({ selfClose }) {
  const location = useLocation();
  const { regId, shibbolethToken } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);

  const handleContinue = async () => {
    if (selfClose) {
      selfClose();
    }

    if (!regId) {
      Auth.goToLandingPage(true);
      return;
    }

    setIsLoading(true);
    try {
      let loginData;
      if (shibbolethToken) {
        const shibbolethInfo = AppStorage.instance.get('shibbolethInfo');
        loginData = {
          providerId: shibbolethInfo?.providerId,
          shibbolethToken: shibbolethInfo?.shibbolethToken,
          grant_type: 'shibboleth',
          registration_id: regId,
        };
        AppStorage.instance.remove('shibbolethInfo');
        await Auth.login(loginData);
      } else {
        await Auth.login({ registration_id: regId }, null, { grant_type: 'register' });
      }
      Login.afterAuthRedirect();
    } catch (error) {
      Logger.error(error);
      setIsLoading(false);
      Auth.goToLandingPage(true);
    }
  };

  return (
    <LoginPageWrapper className="react-page-register-confirmation-page" mainAriaLabel="Registration confirmed screen">
      <div className="confirmation-success-dialog__content">
        <div className="confirmation-success-dialog__header">
          <Logo className="confirmation-success-dialog__logo" />
          <h1 className="confirmation-success-dialog__title u-els-font-size-h3">Confirmed</h1>
        </div>

        <p className="confirmation-success-dialog__description">Registration completed successfully</p>

        <Button
          type="primary"
          expanded
          disabled={isLoading}
          data-e2e="registration-confirmation-success-ok"
          className="confirmation-success-dialog__button e2e-registration-confirmation-success-ok"
          onClick={handleContinue}>
          Continue
        </Button>
      </div>
    </LoginPageWrapper>
  );
}

ConfirmationSuccessDialog.propTypes = {
  selfClose: PropTypes.func,
};

ConfirmationSuccessDialog.defaultProps = {
  selfClose: null,
};

export default ConfirmationSuccessDialog;
